import React from "react";
import { AnualidadProyectoPeriodo } from "../../../../types/AnualidadProyecto";
import { formatMoney, formatPercent } from "../../../helpers/formatters";

export function cantidadColumnas(mostrarContactCenter: boolean) {
  return mostrarContactCenter ? 7 : 3;
}

interface PeriodoHeadersProps {
  mostrarContactCenter: boolean;
}

export function PeriodoHeaders({ mostrarContactCenter }: PeriodoHeadersProps) {
  return (
    <>
      <th className="text-right text-nowrap">Meta</th>
      {mostrarContactCenter && (
        <>
          <th className="text-right text-nowrap resumen-club-yellow">
            Acumulado C.C.
          </th>
          <th className="text-right text-nowrap resumen-club-yellow">
            % Alcance C.C.
          </th>
          <th className="text-right text-nowrap resumen-club-yellow">
            Acumulado Club
          </th>
          <th className="text-right text-nowrap resumen-club-yellow">
            % Alcance Club
          </th>
        </>
      )}
      <th className="text-right text-nowrap">Acumulado</th>
      <th className="text-right text-nowrap">% Alcance</th>
    </>
  );
}

interface Props {
  periodo?: AnualidadProyectoPeriodo;
  mostrarContactCenter: boolean;
}

export default function ResumenClubPeriodoColumns({
  periodo,
  mostrarContactCenter
}: Props) {
  if (!periodo) {
    const columnas = cantidadColumnas(mostrarContactCenter);
    return (
      <>
        {Array.from({ length: columnas }).map((_, i) => (
          <td key={i} className="text-right">
            0.00
          </td>
        ))}
      </>
    );
  }

  return (
    <>
      <td className="text-right">{formatMoney(periodo.metaClubMensual, 2)}</td>
      {mostrarContactCenter && (
        <>
          <td className="text-right resumen-club-yellow">
            {formatMoney(periodo.acumuladoContactCenter, 2)}
          </td>
          <td className="text-right resumen-club-yellow">
            {formatPercent(periodo.alcanceContactCenter)}
          </td>
          <td className="text-right resumen-club-yellow">
            {formatMoney(periodo.acumuladoClub, 2)}
          </td>
          <td className="text-right resumen-club-yellow">
            {formatPercent(periodo.alcanceClub)}
          </td>
        </>
      )}
      <td className="text-right">{formatMoney(periodo.acumuladoTotal, 2)}</td>
      <td className="text-right">
        {formatPercent(periodo.porcentajeCumplimientoReal)}
      </td>
    </>
  );
}
